module.exports = function _isObject(x) {
  return Object.prototype.toString.call(x) === '[object Object]';
};



//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/html-to-react/~/ramda/src/internal/_isObject.js
// module id = hUAA
// module chunks = 0